import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class BookingService {

    getEventRoute = '/api/booking/';

    constructor(private dataService: DataService) {
    };

    getbookingListById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/phire/bookinginfobyid/' + id, refresh)
    }
    getbookingList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/booking/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.bookingStatusType + '/' + data.isCashBooking + '/' + data.financialYearId, refresh);
    }
    getbookingListPaged(data: any, refresh: boolean) {
        return this.dataService.getData('/api/booking/paged/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.bookingStatusType + '/' + data.isCashBooking + '/' + data.financialYearId + '/' + data.pageNumber + '/' + data.pageSize + (data.search ? '?search=' + encodeURIComponent(data.search) : ''), refresh);
    }

    getdepartmentbookingList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/booking/department/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.bookingStatusType + '/' + data.financialYearId, refresh);
    }
    getdepartmentbookingListPaged(data: any, refresh: boolean) {
        return this.dataService.getData('/api/booking/department/paged/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.bookingStatusType + '/' + data.financialYearId + '/' + data.pageNumber + '/' + data.pageSize + (data.search ? '?search=' + encodeURIComponent(data.search) : ''), refresh);
    }

    getrefundbookingList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/refund/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.isRefundinprogress + '/' + data.financialYearId, refresh);
    }

    getSharedVehicleLogBookCheck(refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/sharedVehiclelogbook', refresh);
    }

    getBankAccList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/settlement/list/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId + '/' + data.paymentType +'/'+ data.financialYearId + '/' + data.paymentGatewayId, refresh);
    }

    getPvtSettlementList(data: any) {
        return this.dataService.getData('/api/pvtsettlement/list/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId + '/' + data.financialYearId, true)
    }

    gettreasuryList(data: any, refresh: boolean) {
        return this.dataService.getData('/api/treasury/treasuryList/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId  +'/'+ data.financialYearId, refresh);
    }

    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/booking/' + id, refresh);
    }
    getDepartmentBookingById(bookingId: number, refresh: boolean) {
        return this.dataService.getData('/api/booking/department/' + bookingId, refresh);
    }

    getFailedBookingDetails(data: any, refresh: boolean) {
        return this.dataService.getData('/api/booking/bookingfailed/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.financialYearId, refresh);
    }

    getRework(id: any, refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/rework/' + id, refresh);
    }

    getByIdforrefund(id: number, refresh: boolean) {
        return this.dataService.getData('/api/refund/' + id, refresh);
    }

    getByIdpayoutDetails(data: any, refresh: boolean) {
        return this.dataService.getData('/api/payout/' + data.id, refresh);
    }
    getByIdSettlement(data: any, refresh: boolean) {
        return this.dataService.getData('/api/settlement/' + data.id + '/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId, refresh);
    }

    getByIdpvtReceipt(data: any, refresh: boolean) {
        return this.dataService.getData('/api/pvtsettlement/' + data.id + '/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId, refresh);
    }

    getByIdPoolAc(id: number, refresh: boolean) {
        return this.dataService.getData('/api/settlement/cash/' + id, refresh);
    }

    getByIdTransferData(data: any, refresh: boolean) {
        return this.dataService.getData('/api/treasury/' + data.id + '/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId, refresh);
    }

    bookingAvailability(vehicleId, subdivisionId, paymentId, bookingId, isDepartment, refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/allocateavailability/' + vehicleId + '/' + subdivisionId + '/' + paymentId + '/' + bookingId + '/' + isDepartment, refresh)
    }


    // bookingAvailability(vehicleId, subdivisionId, refresh: boolean) {
    //     return this.dataService.getData('/api/mhirebooking/allocateMiAvailability/' + vehicleId + '/' + subdivisionId, refresh)
    // }



    bookingAvailabilityDate(vehicleCategoryId, blockId, refresh: boolean) {
        // return this.dataService.getData('/api/mhirebooking/availabilityDate/' + vehicleCategoryId + '/' + talukId, refresh)
        return this.dataService.getData('/api/mhirebooking/availabilityDate/' + vehicleCategoryId + '/' + blockId, refresh)

    }

    bookingAvailabilityDateBySubdivision(vehicleCategoryId, UserSubDivision, refresh: boolean) {
        // return this.dataService.getData('/api/mhirebooking/availabilityDate/' + vehicleCategoryId + '/' + talukId, refresh)
        return this.dataService.getData('/api/mhirebooking/availabilityDatebysubdivision/' + vehicleCategoryId + '/' + UserSubDivision, refresh)

    }

    bookingAvailabilityDateByBlock(vehicleCategoryId, UserSubDivision, userBlockId, refresh: boolean) {
        // return this.dataService.getData('/api/mhirebooking/availabilityDate/' + vehicleCategoryId + '/' + talukId, refresh)
        return this.dataService.getData('/api/mhirebooking/availabilityDatebysubdivisionandblock/' + vehicleCategoryId + '/' + UserSubDivision + '/' + userBlockId, refresh)

    }



    bookingAvailabilityById(bookingId, refresh: boolean) {
        return this.dataService.getData('/api/mhirebooking/availability/' + bookingId, refresh)
    }


    updateBooking(data: any) {
        return this.dataService.post('/api/mhirebooking/update', data).map(response => {
            return response;
        });
    }


    oldsave(result: any) {
        return this.dataService.post('/api/mhirebooking/allocateVehicle/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    save(result: any) {
        return this.dataService.post('/api/mhirebooking/allocateVehicles/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    aeeSave(result: any) {
        return this.dataService.post('/api/mhire/refundapprovedsave/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    HoSave(result: any) {
        return this.dataService.post('/api/mhirebooking/SaveHoRemarks', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    aeeVerify(result: any) {
        return this.dataService.post('/api/mhirebooking/refundinprogresssave', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    logBookSave(result: any) {
        return this.dataService.post('/api/mhirelogbook/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    advancesearch(result: any) {
        return this.dataService.post('/api/booking/search/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    getLogBook(id: number, refresh: boolean) {
        return this.dataService.getData('/api/mhirelogbook/' + id, refresh);
    }

    inactiveallocate(id: number, status: number) {
        return this.dataService.post('/api/mhirebooking/updateallocation/' + id + '/' + status, null).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    workcompleted(result: any) {
        return this.dataService.post('/api/mhire/workcompleted/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    aeCancelRequest(result: any) {
        return this.dataService.post('/api/mhirebooking/refundrequestsave/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    cancelbookingrequest(result: any) {
        return this.dataService.post('/api/mhire/cancelbookingrequested/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getcancelbookingbyid(data: any, refresh: boolean) {
        return this.dataService.getData('/api/mhire/cancelbooking/' + data, refresh);
    }


    approvecancelbookingrequest(result: any) {
        return this.dataService.post('/api/mhire/cancelbookingprocessed/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getQuickLogEntries(mdata: any, refresh: Boolean) {
        return this.dataService.getData('/api/mhirelogbook/comparelogbook/' + mdata.bookingId, refresh);
    }


    cancelbooking(data: any) {
        return this.dataService.post('/api/mhire/mhireBookingCancelProcessed', data).map(response => {
            return response;
        });
    }


    getMinorIrrigation(data, refresh: boolean) {
        return this.dataService.getData('/api/mhire/minorirrigationbookeddetail/' + data.subDivisionId + '/' + data.vehicleCategoryId + '/' + data.langType, refresh)
    }


    getLookUptransactiontype(refresh: boolean) {
        return this.dataService.getData('/api/lookup/transactiontype', refresh);
    }

    getLookUpModeOfPaymenttype(refresh: boolean) {
        return this.dataService.getData('/api/lookup/modeofpaymenttype', refresh);
    }

    getheaderList(refresh: boolean) {
        return this.dataService.getData('/api/settlement/headerlist', refresh);
    }

    getcashpaymentsettlements(data, refresh: boolean) {
        return this.dataService.getData('/api/settlement/cashpaymentdetails/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId, refresh);
    }

    getdepartmentpaymentsettlements(data, refresh: boolean) {
        return this.dataService.getData('/api/settlement/departmentpaymentdetails/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId, refresh);
    }

    gettreasurysettlements(refresh: boolean) {
        return this.dataService.getData('/api/settlement/settlementList', refresh);
    }
    getTreasurySettlementsByFarmer(vehicleGroupType, paymentId, refresh: boolean) {
        return this.dataService.getData('/api/treasury/paymentdetails/' + vehicleGroupType + "/" + paymentId, refresh);
    }

    poolacsave(result: any) {
        return this.dataService.post('/api/settlement/poolAccountTransferSave/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    treasurysave(result: any) {
        return this.dataService.post('/api/treasury/treasuryTransferSave/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    blockvillagemappingsave(result: any) {
        return this.dataService.post('/api/subdivision/blockvillagemappingsave', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    hoApproveSave(data: any) {
        return this.dataService.post('/api/settlement/settlementverifiedsave', data).map(response => {
            return response;
        })
    }

    getAeeDetails(refresh: boolean) {
        return this.dataService.getData('/api/settlement/aeeDetails', refresh);
    }

    getCancelLookup(refresh: boolean) {
        return this.dataService.getData('/api/lookup/cancelationtype', refresh);
    }
    getBookingFailed(refresh: boolean) {
        return this.dataService.getData('/api/common/failure', refresh);

    }
    getFailedTraceBooking(id: number, refresh: boolean) {
        return this.dataService.getData('/api/mhire/failtrace/' + id, refresh);

    }
    getGstCheck(gstNo: number, refresh: boolean) {
        return this.dataService.getData('/api/aedsite/' + gstNo, refresh);

    }

    getGstCheckDealer(gstNo: number, refresh: boolean) {
        return this.dataService.getData('/api/aedsite/dealer/' + gstNo, refresh);
    }

    getGstDetailFromGov(gstNo: any, refresh: boolean) {
        return this.dataService.getData('/api/aedsite/dealer/gov/' + gstNo, refresh);
    }

    getNumbercheckmanufactur(data: any, refresh: boolean) {
        return this.dataService.post('/api/dbtmanufacturer/manufacturerRegGenerateOtp', data,);
    }
    approvalmanufacturerapproval(data: any,) {

        return this.dataService.post('/api/dbtfarmertarget/farmerbookingapproval', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    farmersubsidysave(data: any) {
        return this.dataService.post('/api/farmerbookingsubsidy/farmersubsidysave', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    getinspectedby(subDivisionId: any, refresh: boolean) {
        return this.dataService.getData('/api/farmerbookingsubsidy/inspectedbylookup/' + subDivisionId, refresh);
    }
    sendBack(result: any) {
        return this.dataService.post('/api/dbtfarmertarget/sendback', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    book(result: any) {
        return this.dataService.post('/api/dbtfarmertarget/waitinglistbookingsave', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    aadharCheck(farmerId: any, refresh: any) {
        return this.dataService.getData('/api/user/aadharCheck/' + farmerId, refresh);

    }

    aadharVerify(result: any) {
        return this.dataService.post('/api/user/aadharVerify', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    makkaludanMudhalvarsave(result: any) {
        return this.dataService.post('/api/makkaludanmudhalvarfeedback', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    aeworkcompletesave(data: any) {
        return this.dataService.post('/api/phire/aeworkcompletesave', data)
    }
    OtpVerification(data: any, refresh: boolean) {
        return this.dataService.post('/api/user/otpVerify', data,)
    }
    phirebookingcancellation(data: any) {
        return this.dataService.post('/api/phire/phirebookingcancellation', data)
    }

    focsrworkcompletesave(data: any) {
        return this.dataService.post('/api/phire/focsrworkcompletesave', data)
    }

    getPaccsSettlementList(data: any) {
        return this.dataService.getData('/api/paccssettlement/list/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId +'/' + data.financialYearId, true)
    }

    getByIdPaccsReceipt(data: any, refresh: boolean) {
        return this.dataService.getData('/api/paccssettlement/' + data.id + '/' + data.regionId + '/' + data.divisionId + '/' + data.subdivisionId, refresh);
    }

    getDepartmentPayouts(refresh: boolean) {
        return this.dataService.getData('/api/departmentPayout', refresh);
    }

    getDepartmentPayoutDetails(payoutId: number, refresh: boolean) {
        return this.dataService.getData('/api/departmentPayout/details/' + payoutId, refresh);
    }


}
